var React = require('react');

function FlagBh (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M211.862 423.724H8.828A8.829 8.829 0 010 414.896V97.104a8.829 8.829 0 018.828-8.828h203.034v335.448z","fill":"#f5f5f5","key":0}),React.createElement("path",{"d":"M141.241 88.277l70.621 20.965-70.621 20.965 70.621 20.965-70.621 20.965 70.621 20.965-70.621 20.965 70.621 20.965-70.621 20.965 70.621 20.965-70.621 20.965 70.621 20.965-70.621 20.965 70.621 20.965-70.621 20.965 70.621 20.965-70.621 20.965h361.93a8.829 8.829 0 008.828-8.828V97.104a8.829 8.829 0 00-8.828-8.828h-361.93v.001z","fill":"#ff4b55","key":1})]);
}

FlagBh.defaultProps = {"viewBox":"0 0 511.999 511.999"};

module.exports = FlagBh;

FlagBh.default = FlagBh;
